// extracted by mini-css-extract-plugin
module.exports = {"preferencesTable":"Edit_preferencesTable__2_qdi"};